"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggleEventFavourite = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const slice_1 = require("../containers/FavouritesProvider/slice");
const selectors_1 = require("../containers/FavouritesProvider/selectors");
const useToggleEventFavourite = (eventId) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isEventFavourite = (0, react_redux_1.useSelector)((state) => (0, selectors_1.selectIsEventFavourite)(state, eventId));
    const toggleEventFavourite = (0, react_1.useCallback)(() => {
        if (isEventFavourite) {
            dispatch(slice_1.favouritesProviderActions.deleteFavouriteEvent({ eventId }));
        }
        else {
            dispatch(slice_1.favouritesProviderActions.createFavouriteEvent({ eventId }));
        }
    }, [dispatch, isEventFavourite, eventId]);
    return { isEventFavourite, toggleEventFavourite };
};
exports.useToggleEventFavourite = useToggleEventFavourite;
//# sourceMappingURL=useToggleEventFavourite.js.map